import { Link, LinkProps } from 'react-router-dom'

import { config } from '@/config'
import { useTheme } from '@/contexts/ThemeProvider'
import { RoutePaths } from '@/routes'
import { cn } from '@/theme/utils'

export default function Logo(
  props: Omit<LinkProps, 'to'> & { orientation?: 'horizontal' | 'vertical' },
) {
  const { theme, systemTheme } = useTheme()

  const currentTheme = theme === 'system' ? systemTheme : theme

  return (
    <Link
      {...props}
      to={RoutePaths.Root}
      className={cn(
        'flex w-full max-w-46 items-center gap-4',
        props.orientation === 'vertical' && 'flex-col',
        props.className,
      )}
    >
      <img
        src={
          currentTheme === 'dark'
            ? `${import.meta.env.BASE_URL}branding/logo-large-dark.svg`
            : `${import.meta.env.BASE_URL}branding/logo-vertical.svg`
        }
        alt={config.VITE_APP_NAME}
        className='h-auto w-40.75 object-contain'
      />
    </Link>
  )
}
